import './index.scss';
import classNames from 'classnames';
import React from 'react';
import Chevron from '~/components/chevron';
import TreeView from '~/components/tree_view';
const SelectFolderInput = (props) => {
    const { ToggleFolderExpansion, isExpanded, projectsWorkspaces, onFolderSelect, selectedId, showTopLevelOption, selectedDisplay, isArchivedVisible = false, } = props;
    const inputClasses = classNames('form-text-input input disabled', {
        'is-expanded': isExpanded,
    });
    const topOptionSelectedContainerClass = classNames('folder-option-row-container', {
        'item-selected': selectedId === 'top-level-option',
    });
    const topOptionSelectedDisplayClass = classNames('folder-option-display', {
        'item-selected': selectedId === 'top-level-option',
    });
    const turnIntoTreeNodes = (projWorks) => {
        var _a;
        return (_a = projWorks === null || projWorks === void 0 ? void 0 : projWorks.filter(p => isArchivedVisible || !p.isArchived)) === null || _a === void 0 ? void 0 : _a.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1).map(pw => {
            return {
                id: pw.id,
                name: pw.name,
                children: turnIntoTreeNodes(pw.children),
                isArchived: pw.isArchived,
            };
        });
    };
    const filteredProjectsWorkspaces = projectsWorkspaces
        ? turnIntoTreeNodes(projectsWorkspaces)
        : null;
    return (React.createElement("div", { className: 'folder-selector-input' },
        React.createElement("span", { className: 'input-container has-right-icon', onClick: ToggleFolderExpansion },
            React.createElement("span", { className: "right-icon" },
                React.createElement("span", { className: 'folder-chevron' },
                    React.createElement(Chevron, { title: 'Expand', isExpanded: isExpanded }))),
            React.createElement("input", { disabled: true, className: inputClasses, placeholder: 'Select location', onClick: ToggleFolderExpansion, value: selectedDisplay })),
        isExpanded && filteredProjectsWorkspaces &&
            React.createElement("div", { className: 'tree-view-folder-expansion' },
                showTopLevelOption && React.createElement("div", { className: 'top-level-folder-option' },
                    React.createElement("div", { className: "folder-option-row" },
                        React.createElement("div", { className: topOptionSelectedContainerClass },
                            React.createElement("span", { className: topOptionSelectedDisplayClass },
                                React.createElement("span", null,
                                    React.createElement("i", { className: "fa-regular fa-folder-open" })),
                                React.createElement("button", { className: "folder-option-name", onClick: () => onFolderSelect({ id: 'top-level-option', name: 'Projects' }), title: 'Projects' }, "Projects"))))),
                React.createElement("div", { className: 'tree-folder-options' },
                    React.createElement(TreeView, { additionalCollapseIcon: "fa-regular fa-folder-open", additionalExpandIcon: "fa-regular fa-folder", selectedId: selectedId, onNodeSelect: onFolderSelect, data: filteredProjectsWorkspaces })))));
};
export default SelectFolderInput;
